// Components
export {
  MediaUploader,
  type MediaUploaderProps,
  type MediaUploaderTranslations,
} from './components/media-uploader';
export {
  MediaThumb,
  inferCategory,
  thumbnailSrc,
  type MediaCategory,
} from './components/media-thumb';
export {
  MediaLightbox,
  type MediaLightboxTranslations,
} from './components/media-lightbox';
export {
  MediaPicker,
  type MediaPickerProps,
  type MediaPickerLibraryItem,
  type MediaPickerTranslations,
  type PickerMediaType,
} from './components/media-picker';
export {
  MuxHlsPlayer,
  type MuxHlsPlayerProps,
} from './components/mux-hls-player';

// Hooks
export {
  useMediaUpload,
  type MediaFile,
  type UploadResult,
  type UploadTranslations,
  type UseMediaUploadOptions,
} from './hooks/use-media-upload';
export { useMuxHls } from './hooks/use-mux-hls';

// Video render-source resolution (shared by app surfaces + the picker cluster)
export {
  resolveVideoSource,
  r2VideoUrl,
  type VideoRenderSource,
  type VideoSourceInput,
} from './lib/video-source';

// Constants
export {
  buildAcceptAttribute,
  FILE_TYPES,
  FILE_SIZE_LIMITS,
  UPLOADER_PRESETS,
  type AcceptType,
  type FileType,
  type UploaderPreset,
} from './lib/constants';

// Validation utilities
export {
  validateFile,
  formatFileSize,
  getFileTypeLabels,
  getFileCategory,
  getFilenameWithoutExtension,
  type FileValidationResult,
  type FileValidationOptions,
} from './lib/validation';
